import React, { useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

interface BusinessCardImageModalProps {
  open: boolean;
  src: string | undefined;
  alt: string;
  flutterFooterHeight?: number;
  onClose: () => void;
}

const BusinessCardImageModal: React.FC<BusinessCardImageModalProps> = ({
  open,
  src,
  alt,
  flutterFooterHeight = 0,
  onClose,
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: `${flutterFooterHeight}px`,
        background: 'rgba(0, 0, 0, 0.85)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <button
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          background: 'rgba(0, 0, 0, 0.3)',
          border: 'none',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#fff',
          fontSize: 18,
          zIndex: 1,
        }}
        onClick={(e) => { e.stopPropagation(); onClose(); }}
      >
        <CloseOutlined />
      </button>
      {/* TransformWrapper のクリックで閉じないよう伝播を止める */}
      <div
        style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        onClick={(e) => e.stopPropagation()}
      >
        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={5}
          doubleClick={{ mode: 'toggle' }}
          panning={{ velocityDisabled: false }}
        >
          <TransformComponent
            wrapperStyle={{ width: '100%', height: '100%' }}
            contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <img
              src={src}
              alt={alt}
              style={{ maxWidth: '90dvw', maxHeight: `calc(100dvh - ${flutterFooterHeight}px - env(safe-area-inset-bottom, 0px))`, objectFit: 'contain' }}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>
  );
};

export default BusinessCardImageModal;
